import type { FC } from 'react'

import PlusIcon from '@/assets/icons/icon-plus.svg'
import { Button } from '@/components/ui/button.tsx'
import { SearchInput } from '@/components/ui/search-input.tsx'
import { Tooltip } from '@/components/ui/tooltip.tsx'
import { classNames } from '@/utils/helpers.ts'

interface Props {
  onCreateListPress: () => void
  setFilter: (filter: string) => void
  disabled: boolean
}

export const CustomListsHeaderButtons: FC<Props> = ({
  onCreateListPress,
  setFilter,
  disabled,
}) => {
  return (
    <div className="flex items-center gap-2">
      <SearchInput
        placeholder="Search"
        onInputChange={setFilter}
      />
      <Tooltip
        asChild
        content={
          disabled
            ? 'You’ve reached the limit of 10 custom lists. Please delete one to create a new list'
            : 'Create a new Custom List'
        }
      >
        <Button
          className={classNames('gap-1', {
            // hack to allow to show tooltip for disabled state
            'disabled:pointer-events-auto': disabled,
          })}
          onClick={onCreateListPress}
          testId="create-list-button"
          disabled={disabled}
        >
          <PlusIcon />
          <span className="inline">Create List</span>
        </Button>
      </Tooltip>
    </div>
  )
}
